export const step: Record<"DATE" | "OTHER", string> = {
  //0:不可選   1:可選
  DATE: "0",
  OTHER: "1",
};
